import { useState } from "react";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { useToast } from "@/hooks/use-toast";
import { CreditCard, Settings2 } from "lucide-react";
import PaymentProviderList from "./payment/PaymentProviderList";

const PaymentSettings = () => {
  const { toast } = useToast();
  const [isLoading, setIsLoading] = useState(false);

  const handleSaveSettings = async () => {
    setIsLoading(true);
    try {
      // Simulate API call
      await new Promise(resolve => setTimeout(resolve, 1000));
      
      toast({
        title: "Settings Saved",
        description: "Payment integration settings have been updated successfully.",
      });
    } catch (error) {
      toast({
        variant: "destructive",
        title: "Error",
        description: "Failed to save settings. Please try again.",
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <Settings2 className="h-5 w-5" />
          Payment Integration Settings
        </CardTitle>
        <CardDescription>Configure and manage payment gateway integrations</CardDescription>
      </CardHeader>
      <CardContent className="space-y-6">
        <PaymentProviderList />

        <Button
          onClick={handleSaveSettings}
          disabled={isLoading}
          className="w-full"
        >
          <CreditCard className="mr-2 h-4 w-4" />
          {isLoading ? "Saving..." : "Save Payment Settings"}
        </Button>
      </CardContent>
    </Card>
  );
};

export { PaymentSettings };